import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BuildingSavingsCreateFormFields } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/BuildingSavingsCreateFormFields";
import { useCreateBuildingSavingsForm } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/useCreateBuildingSavingsForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

export const CreateBuildingSavingsForm = () => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreateBuildingSavingsForm();

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<BuildingSavingsCreateFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
